import { Checkbox, Icon, ImageFallback, Text, HStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { Pressable } from 'native-base';
import React, { useCallback, useMemo } from 'react';

import {
  TableContent,
  TableContentItemColumn,
  TableContentItemText,
} from '../../../../../../components/TableContent';
import {
  AssetsFundsControl,
  CustomItemTagObject,
} from '../../../../../../store/ProducManagement/types';
import { IDynamicProductSearchItem } from '../../_dynamic';
import { ItemTag } from '../../ItemTag';

import { tableHead } from './constants';

const ProductSearchItem = ({
  item,
  selectedItems,
  onSelect,
  onDetails,
}: IDynamicProductSearchItem<AssetsFundsControl>) => {
  const getFlex = useCallback((index: number) => {
    const currentHead = tableHead.find((_, i) => i === index);
    return currentHead?.flex || 1;
  }, []);

  const handleSelect = useCallback(
    (value: string) => {
      onSelect(value);
    },
    [onSelect]
  );

  const handleDetails = useCallback(() => {
    onDetails(item.productId, item.managerImage, item.fundName);
  }, [onDetails, item.productId, item.managerImage, item.fundName]);

  const isSelected = useMemo(
    () => selectedItems.includes(item.productId.toString()),
    [selectedItems, item.productId]
  );

  return (
    <TableContent
      direction="row"
      space={Spacing['stack.nano']}
      py={Spacing['stack.xxs']}
      px={Spacing['inline.xxxs']}>
      <TableContentItemColumn flex={0.5}>
        <Checkbox
          key={item.productId}
          optionPadding={{ bottom: 0, right: 0 }}
          options={[{ label: '', value: item.productId.toString() }]}
          onChange={handleSelect}
          testId="checkbox-select-all"
          selectedValues={isSelected ? [item.productId.toString()] : []}
        />
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(0)}>
        <ImageFallback
          src={item.managerImage}
          alt="logo"
          width="54px"
          height="48px"
          testID="product-img"
          resizeMode="cover"
          borderRadius={BoxRadius.sm}
          resizeMethod="scale"
        />
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(1)}>
        <TableContentItemText>{item.fundCnpj}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(2)}>
        <TableContentItemText>{item.fundCategory}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(3)}>
        <TableContentItemText numberOfLines={1} ellipsizeMode="tail">
          {item.fundName}
        </TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(4)}>
        <ItemTag data={(item.tags as unknown as CustomItemTagObject[]) || []} />
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(5)}>
        <Pressable testID="button-item" onPress={handleDetails}>
          <HStack alignItems="center" space={Spacing['inline.nano']}>
            <Text
              color={'brand.tertiary.principal'}
              variant="semibold"
              fontSize={Typography['fontsize.md']}>
              DETALHES
            </Text>
            <Icon name="ChevronRight" size={'xxxs'} color={Color['brand.tertiary.principal']} />
          </HStack>
        </Pressable>
      </TableContentItemColumn>
    </TableContent>
  );
};

export default React.memo(ProductSearchItem, (prevProps, nextProps) => {
  return (
    prevProps.item.productId === nextProps.item.productId &&
    prevProps.selectedItems.includes(prevProps.item.productId.toString()) ===
      nextProps.selectedItems.includes(nextProps.item.productId.toString())
  );
}) as any;
